<template>
    <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="innerValue"
        persistent
        full-width
        width="290px"
    >

        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="innerValue"
                :label="label"
                outlined
                readonly
                v-on="on"
                :rules="rules"
            />
        </template>
        <v-date-picker v-model="innerValue" scrollable>
            <v-spacer/>
            <v-btn color="red lighten-1" class="white--text" @click="modal = false">Cancel</v-btn>
            <v-btn color="primary" @click="$refs.dialog.save(innerValue)">OK</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>

    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [];
                },
            },
            label: {
                type: String,
                value: ''
            },
            value: {
                type: null
            }
        },
        name: "DatePicker",
        data() {
            return {
                modal: false,
                innerValue: null
            }
        },
        watch: {
            innerValue(new_value) {
                this.$emit('input', new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            }
        },
        created() {
            if (this.value) {
                this.innerValue = this.value;
            }
        }
    }
</script>
